import './lottie.module.css'
import { LottiePlayer } from './lottie-player.ts'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  if (!customElements.get('lottie-player')) {
    customElements.define('lottie-player', LottiePlayer)
  }
}
